;
jQuery(function(){

    /**
     * Función para obtener las últimas concesiones
     */
    function getUltimasConcesiones(force = false){
        if($('#admin-concesiones-table-body').length > 0 || force){
            $.ajax({
                url: uaGetConcesiones,
                dataType: 'json',
                type: 'GET',
                contentType: 'application/json',
                success: function(data) {
                    // console.log(data);
                    if(data.data.concesiones.length > 0){
                        $('#main-table').DataTable().clear();
                        for(x=0;x<data.data.concesiones.length;x++){
                            c = data.data.concesiones[x];
                            tr = '<tr>';

                            if(c.concesionarios.length > 0){
                                tr+= '<td width="10%">'+c.concesionarios[0].tx_curp+'</td>';
                                tr+= '<td width="35%">'+c.concesionarios[0].tx_nombre+' ';
                                tr+= ''+c.concesionarios[0].tx_primer_apellido+' ';
                                tr+= ''+c.concesionarios[0].tx_segundo_apellido+'</td>';
                            }else{
                                tr+= '<td width="10%">&nbsp;</td>';
                                tr+= '<td width="35%">&nbsp;';
                                tr+= '&nbsp;';
                                tr+= '&nbsp;</td>';
                            }
                            tr+= '<td width="10%">'+c.tx_placa+'</td>'
                            tr+= '<td width="10%">'+c.tipo_concesion.tx_tipo_concesion+'</td>'
                            tr+='<td width="35%">';
                            tr+= '<form method="POST" id="admin-ver-concesion-'+c.id+'" action="'+adminDetalleConcesion+'">';
                            tr+= '<input type="hidden" name="_token" id="" value="'+$('meta[name="csrf-token"]').attr('content')+'">';
                            tr+= '<input type="hidden" name="idConcesion" id="idConcesion" value="'+c.id+'">';
                            tr+= '<input type="hidden" name="action" id="action-'+c.id+'" value=""></form>';
                            tr+='<button id="btn-admin-ver-concesion" concesion="'+c.id+'" type="button" class="btn-admin-concesion-semovi btn btn-cdmx btn-shadow" title="Ver detalles de la concesión"><span class="fa fa-eye"></span></button>';
                            tr+='<button id="btn-admin-edita-concesion" concesion="'+c.id+'" type="button" class="btn-admin-concesion-semovi btn btn-cdmx-amarillo btn-shadow" title="Editar concesión"><span class="fa fa-edit"></span></button>';
                            tr+= '<form style="display:none;" method="POST" id="admin-eliminar-concesion-'+c.id+'" action="'+adminDeleteConcesion+'">';
                            tr+= '<input type="hidden" name="_token" value="'+$('meta[name="csrf-token"]').attr('content')+'">';
                            tr+= '<input type="hidden" name="idConcesion" id="idConcesion" value="'+c.id+'">';
                            tr+= '<input type="hidden" name="_method" value="DELETE">';
                            tr+= '</form>'
                            tr+='<button id="btn-admin-borra-concesion" concesion="'+c.id+'" type="button" class="btn-admin-concesion-semovi btn btn-cdmx-rojo btn-shadow" title="Eliminar concesión"><span class="fa fa-trash"></span></button>';
                            tr+='</td></tr>';

                            oTr = $(tr);
                            $('#main-table').DataTable().row.add(oTr);
                        }

                        $('#main-table').DataTable().draw();
                        $('#main-table').removeClass('d-none');
                        $('#no-concesion').addClass('d-none');

                    }

                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-admin').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-admin').removeClass('d-none');
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                }
            });
        }
    }



    /**
     * Función para obtener los últimos movimientos
     */
     function getUltimosMovimientos(force = false){
        if($('#consulta-operadores-table-body').length > 0 || force){
            $.ajax({
                url: uMovsListar,
                dataType: 'json',
                type: 'GET',
                contentType: 'application/json',
                success: function(data) {
                    // console.log(data);
                    $('#chkPlacaLog').trigger('click');
                    $('#remove-filter-log').remove();
                    $('#reportes-clear-filter').remove();
                    if(data.data.moves.length > 0){
                        for(x=0;x<data.data.moves.length;x++){
                            c = data.data.moves[x];
                            tr = '<tr>';
                            tr+= '<td width="20%">'+(c.operador ? c.operador.tx_curp : 'N/A')+'</td>';
                            tr+= '<td width="20%">'+(c.operador ? c.operador.tx_nombre+' ' : 'N/A');
                            tr+= ''+(c.operador ? c.operador.tx_primer_apellido+' ' : '');
                            tr+= ''+(c.operador ? c.operador.tx_segundo_apellido : '')+'</td>';
                            tr+= '<td width="50%">'+c.tx_movimiento+'</td>';
                            tr+='<td width="10%">';
                            tr+='<button id="btn-admin-ver-mov" mov="'+c.id+'" type="button" class="btn-move btn btn-cdmx btn-shadow">Detalles</button>';
                            tr+='</td></tr>';

                            oTr = $(tr);
                            $('#main-table').DataTable().row.add(oTr);
                        }

                        $('#main-table').DataTable().draw();

                    }

                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-admin').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-admin').removeClass('d-none');
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                }
            });
        }
    }


    /**
     * Funcion para buscar la concesión en semovi por placa
     * (solo para taxis)
     */
     function adminValidaSemovi(){
        $('#modal-zagruzka').modal('show');
        tipo = $('#tpConcesionTaxi').is(':checked') ? 'taxi' : 'ruta';
        // Verifica si es la pantalla de edición
        if($('#idKey').length == 0){ // Pantalla agregar
            $('#error-container').addClass('d-none');
            placa = $('#txPlaca').val();
            $.ajax({
                url: uConsultaSemovi+tipo+'/'+placa,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data:'{"vin":"'+$('#txVIN').val()+'", "curp":"'+$('#txCurpConcesionario').val()+'", "backoffice":true, "ig":false}',
                success: function(data) {
                    $('#admin-valida-concesion').attr('disabled', true);
                    $('#txPlaca').attr('disabled', true);
                    $('#txVIN').attr('disabled', true);
                    $('.valida-veh-radio').attr('disabled', true);

                    $('#operators-section').removeClass('d-none');
                    if(data.data.operadores.length > 0){
                        $('#operadores-table-body').find('tr:first').remove(); // quitar el "no data available"
                        $('#operators-table').removeClass('d-none');
                        $('#no-operators').addClass('d-none');
                        for(x=0;x<data.data.operadores.length;x++){
                            tr = '<tr>';
                            tr+= '<td>'+(x+1)+'</td>';
                            tr+= '<td>'+(data.data.operadores[x].curp_licencia||data.data.operadores[x].tx_curp)+'</td>';
                            tr+= '<td>'+data.data.operadores[x].tx_nombre+'</td>';
                            tr+= '<td>'+data.data.operadores[x].tx_primer_apellido+'</td>';
                            tr+= '<td>'+data.data.operadores[x].tx_segundo_apellido+'</td>';
                            tr+= '<td>'+(data.data.operadores[x].tx_email||'')+'</td>';
                            tr+= '<td>'+(data.data.operadores[x].tx_telefono||'')+'</td>';
                            tr+= '<td class="bote"><i class="fa fa-trash asterisk" aria-hidden="true" title="Eliminar operador" role="button" curp="'+(data.data.operadores[x].curp_licencia||data.data.operadores[x].tx_curp)+'"></i></td>';
                            $('#operadores-table-body').append(tr);
                        }
                    }
                    $('#modal-zagruzka').modal('hide');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-container').removeClass('d-none');
                        $('#txCurpConcesionario').val('');
                        $('#txConcesionarioPrimerApellido').val('');
                        $('#txConcesionarioSegundoApellido').val('');
                        $('#txConcesionarioNombres').val('');
                        $('#txPlaca').val('');
                        $('#txVIN').val('');
                        $('#admin-valida-concesion').attr('disabled', true);
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                    $('#modal-zagruzka').modal('hide');
                }
            });
        }else{ // Pantalla actualizacion
            placa = $('#txPlaca').val();
            $.ajax({
                url: uAddConces+tipo+'/'+placa,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data:'{"vin":"'+$('#txVIN').val()+'", "curp":"'+$('#txCurpConcesionario').val()+'", "backoffice":true, "ig":true}',
                success: function(data) {
                    $('#admin-valida-concesion').attr('disabled', true);
                    $('#txPlaca').attr('disabled', true);
                    $('#txVIN').attr('disabled', true);
                    $('#txCurpConcesionario').attr('disabled', true);
                    $('.valida-veh-radio').attr('disabled', true);

                    $('#modal-zagruzka').modal('hide');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-container').removeClass('d-none');
                        $('#txCurpConcesionario').val('');
                        $('#txConcesionarioPrimerApellido').val('');
                        $('#txConcesionarioSegundoApellido').val('');
                        $('#txConcesionarioNombres').val('');

                        $('#admin-valida-concesion').attr('disabled', true);
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                    $('#modal-zagruzka').modal('hide');
                }
            });
        }
    }

    function adminValidaSemoviBtn(){
        console.log(
            (/^(([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d))$/.test($('#txCurpConcesionario').val()))
        );
        if(
            (/^(([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d))$/.test($('#txCurpConcesionario').val()))
            && (/[A-Z0-9]{3,10}/.test($('#txPlaca').val()))
            && (/[A-Z0-9]{9,17}/.test($('#txVIN').val()))
            && ($('#tpConcesionTaxi').is(':checked') || $('#tpConcesionRuta').is(':checked'))
        ){
            $('#admin-valida-concesion').attr('disabled', false);
            $('#add-concesion').removeClass('was-validated');
        }else{
            $('#admin-valida-concesion').attr('disabled', true);
            $('#add-concesion').addClass('was-validated');
        }
    }




    /**
     * Campos que activan la búsqueda de concesión en Semovi
     */
    $('.admin-valida-veh').on('keyup paste', function(e){
        adminValidaSemoviBtn();
    });
    $('.admin-valida-veh-radio').on('click', function(e){
        adminValidaSemoviBtn();
    });

    $('#admin-valida-concesion').on('click', function(e){
        adminValidaSemovi();
    });


    /**
     * Busqueda de curp para agregar concesionario
     *
     * */
    $('#txCurpConcesionario').on('keyup', function (e) {
        if ($(this).val() != '' && /^(([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d))$/.test($(this).val())) {
            $.ajax({
                url: uCURP,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    tx_curp: $(this).val()
                }),
                success: function (data) {
                    $('#txConcesionarioNombres').val(data.txNombres);
                    $('#txConcesionarioPrimerApellido').val(data.txApellidoPaterno);
                    $('#txConcesionarioSegundoApellido').val(data.txApellidoMaterno);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    err = jqXHR.status == 419 ? 'Tu sesión ha caducado, por favor inicia sesión de nuevo' : jqXHR.responseJSON.message || jqXHR.responseJSON.respuesta;
                    $('#txConcesionarioNombres').val('');
                    $('#txConcesionarioPrimerApellido').val('');
                    $('#txConcesionarioSegundoApellido').val('');
                    $('#txCurpConcesionario').val('');
                    $('#admin-valida-concesion').attr('disabled', true);
                    __crearMensaje(true, "Error", err);
                }
            });
        }else{
            $('#txConcesionarioNombres').val('');
            $('#txConcesionarioPrimerApellido').val('');
            $('#txConcesionarioSegundoApellido').val('');
        }
    });




    /**
     * Boton para enviar el formulario y guardar concesion/ops
     * (operador semovi)
     * 
     */
    $('#btn-admin-guardar-conce').on('click', function(e){
        $('#modal-zagruzka').modal('show');
        $.ajax({
            url: adminGuardarConcesion,
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data:'{"backoffice":true}',
            success: function(data) {
                location.href = adminGuardarConcesion;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 401 || jqXHR.status === 419){
                    __crearMensaje(true,"Error","Tu sesión ha caducado");
                }else if(jqXHR.status === 418){
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }else{
                    $('#error-op-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    $('#error-op-container').removeClass('d-none');
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }
                $('#modal-zagruzka').modal('hide');
            }
        });
    });



    /**
     * Botones de Agregar, editar, concesiones
     * 
     */
    $('#app-admin-concesiones').on('click', '.btn-admin-concesion-semovi', function(e){
        kual = $(this).attr('id');
        c = parseInt($(this).attr('concesion'));
        
        console.log(c);
        
        switch(kual){
            case 'btn-admin-edita-concesion':{
                $('#action-'+c).val('edit');
                $('#admin-ver-concesion-'+c).trigger('submit');
                break;
            }
            case 'btn-admin-ver-concesion':{
                $('#action-'+c).val('view');
                $('#admin-ver-concesion-'+c).trigger('submit');
                break;
            }
            case 'btn-admin-borra-concesion':{
                if (window.confirm('¿Deseas eliminar esta concesión?')) {
                    $('#admin-eliminar-concesion-'+c).trigger('submit');
                }
                break;
            }
        }

    });



    /**
     * Botones de tipo de búsqueda
     * 
     */
    $("[name=searchOption]").on('click', function(e){
        kual = $(this).attr('for');
        switch(kual){
            case 'chkPlaca':{
                tipo = 'placa';
                $('#qid').text('Placa:')
                break;
            }
            case 'chkConcesionario':{
                tipo = 'concesionario';
                $('#qid').text('Nombre del concesionario:')
                break;
            }
            case 'chkOperador':{
                tipo = 'operador';
                $('#qid').text('Nombre del operador:')
                break;
            }
            case 'chkCurpOperador':{
                tipo = 'curp-operador';
                $('#qid').text('CURP del operador:')
                break;
            }
            default:{
                tipo = 'placa';
                $('#qid').text('Placa:')
                break;
            }
        }
        $('#searchType').val(tipo);
        $('#q').val('');
        $('#remove-filter').remove();
        getUltimasConcesiones(true);
    });
    // Conculta movs
    $("[name=chkLog]").on('click', function(e){
        kual = $(this).val();
        switch(kual){
            case 'placa':{
                $('#qid').text('Placa:')
                break;
            }
            case 'concesionario':{
                $('#qid').text('CURP o nombre del concesionario:')
                break;
            }
            case 'operador':{
                $('#qid').text('CURP o nombre del operador:')
                break;
            }
            default:{
                $('#qid').text('Placa:')
                break;
            }
        }
        $('#q').val('');
    });


    $('#remove-filter').on('click', function(){ getUltimasConcesiones(true); $('#q').val(''); $(this).remove(); });
    $('#btn-limpiar-filtro').on('click', function(){ getUltimasConcesiones(true); $('#q').val(''); $('#remove-filter').remove() });
    $('#reportes-clear-filter, #remove-filter-log').on('click', function(){ getUltimosMovimientos(true); $('#q').val(''); });




    /**
     * Alternar vistas de reportes
     * 
     */
     $("[name=reporteOption]").on('click', function(e){
        kual = $(this).attr('for');
        
        switch(kual){
            case 'chkTotales':{
                $('#section-logs').addClass('d-none');
                $('#section-totales').removeClass('d-none');
                break;
            }
            case 'chkConsultaOperadores':{
                $('#section-totales').addClass('d-none');
                $('#section-logs').removeClass('d-none');
                break;
            }

        }

    });



    /**
     * Botones para detalle de movimiento
     * 
     */
     $('#section-logs').on('click', '#btn-admin-ver-mov', function(e){
        m = parseInt($(this).attr('mov'));
        $.ajax({
            url: uMov,
            dataType: 'json',
            type: 'POST',
            data: '{"idMov": '+m+'}',
            contentType: 'application/json',
            success: function(data) {
                mo = data.data.move;
                $('#fhMov').val(mo.created_at);
                $('#txCurpOp').val( mo.operador !== null ? mo.operador.tx_curp: 'N/A' );
                $('#txPlaca').text(mo.concesion !== null ? mo.concesion.tx_placa : 'N/A');
                $('#nbConcesionario').val(mo.concesionario !== null ? mo.concesionario.tx_nombre+' '+mo.concesionario.tx_primer_apellido+' '+mo.concesionario.tx_segundo_apellido+' ('+mo.concesionario.tx_curp+')' : 'N/A');
                $('#txMov').val(mo.tx_movimiento);
                $('#txOld').val(mo.tx_old_value);
                $('#txNew').val(mo.tx_new_value);
                $('#usrAlta').val(mo.usrAlta);
                $('#kual-origen').text(mo.origen.nb_origen);
                $('#kual-origen').attr('title', mo.origen.nb_origen);
                cl = '';
                switch(mo.origen.id){
                    case 1:{
                        cl = 'bubble-webapp';
                        break;
                    }case 2:{
                        cl = 'bubble-appcdmx';
                        break;
                    }
                    case 3:{
                        cl = 'bubble-migracion-datos';
                        break;
                    }
                    default:{
                        console.log(mo.origen.id);
                        cl = '';
                        break;
                    }
                }
                $('#kual-origen').removeClass();
                $('#kual-origen').addClass(cl)
                if(mo.st_admin_semovi === 1){
                    $('#was-admin-semovi').removeClass('d-none');
                }else{
                    $('#was-admin-semovi').addClass('d-none');
                }
                $('#txUUID').text(mo.tx_uuid);
                if(mo.concesion !== null){
                    $('.placa-fragment').removeClass('d-none');
                }else{
                    $('.placa-fragment').addClass('d-none');
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 401 || jqXHR.status === 419){
                    __crearMensaje(true,"Error","Tu sesión ha caducado");
                }else if(jqXHR.status === 418){
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }else{
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }
            }
        });





        $('#modal-detalle-movimiento').modal('show');
    });



    getUltimasConcesiones();
    getUltimosMovimientos();

});
